import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, AfterViewChecked, Input, OnChanges } from '@angular/core';
import { IonContent, DomController } from '@ionic/angular';

import { Helpers, BaseComponent } from 'ngx-elvis-ds';
import { ThemeService } from 'ngx-elvis-ds';
import { CartService } from 'src/app/services/cart.service';
import { SAMSessionService } from 'src/app/sam/sam-session.service';
import { SAMService } from 'src/app/sam/sam.service';
import { I18NService } from 'src/app/services/i18n.service';
import { ConfigService } from 'src/app/config.service';

@Component({
  selector: 'mem-sco-cart',
  templateUrl: './sco-cart.component.html',
  styleUrls: ['./sco-cart.component.scss']
})
export class SCOCartComponent extends BaseComponent implements AfterViewInit {

  @ViewChild('cart', { static: true }) cart: ElementRef;
  @ViewChild('receipt', { static: true }) receipt: ElementRef;
  @ViewChild('content', { static: true }) content: IonContent;

  constructor(
    public samSessionSvc: SAMSessionService,
    public sam: SAMService,
    public cartSvc: CartService,
    public themeSvc: ThemeService,
    private domCtrl: DomController,
    public i18nSvc: I18NService,
    public configSvc: ConfigService,
  ) {
    super();
  }

  onItemVoid(item) {
    this.sam.onSend({
      Command: 'VOID_PLU',
      Val: `${item.ItemInd}`,
      parms: {
        id: String(item.ItemInd),
        itemInd: String(item.ItemInd)
      }
    });
  }

  ngAfterViewInit() {
    window.addEventListener('resize', () => { this.setReceiptMargin(); });
    this.cartSvc.events.subscribe(() => {
      this.setReceiptMargin();
    });

    setTimeout(() => {
      this.setReceiptMargin();
    }, 500);

    this.domCtrl.write(() => {
      const content = document.querySelector('#sco-cart');
      Helpers.styleScrollbars(content);
    });
  }

  // private

  private setReceiptMargin() {
    this.domCtrl.write(() => {
      const cartSizes = this.cart.nativeElement.getBoundingClientRect();
      // const receiptSizes = this.receipt.nativeElement.getBoundingClientRect();
      const newReceiptMargin = cartSizes.height  - (this.cartSvc.cart.length * 65) - 150 - (this.cartSvc.cart.length === 0 ? 65 : 0);
  
      this.receipt.nativeElement.style.transform = `translate3D(0, ${Math.max(newReceiptMargin, 0)}px, 0)`;
  
      if (newReceiptMargin < 0 && cartSizes.height) {
        this.content.scrollToBottom(1000);
      }
  
      setTimeout(() => {
        this.receipt.nativeElement.classList.add('visible');
      }, 1250);
    });
  }

}
